/**
 * Aquanara Beauty — Core JS
 * Handles Cart Drawer, bilingual switcher, quantity pickers, FAQ accordions, and preview events.
 */

document.addEventListener('DOMContentLoaded', () => {
  initMobileNav();
  initCartDrawer();
  initLanguageSwitcher();
  initFaqAccordion();
  initPdpGallery();
  initQuantityPickers();
  initHeaderScroll();
  
  const currentLang = (document.documentElement.lang || 'es').substring(0, 2).toLowerCase();
  switchLanguage(currentLang);
});

function initHeaderScroll() {
  const header = document.querySelector('header.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) { header.classList.add('scrolled'); } else { header.classList.remove('scrolled'); }
  });
}

let cart = { items: [], subtotal: 0, freeShippingThreshold: 50.00 };

function initCartDrawer() {
  const cartBtn = document.querySelector('.cart-icon-btn');
  const overlay = document.querySelector('.cart-drawer-overlay');
  const closeBtn = document.querySelector('.cart-drawer-close');
  if (cartBtn && overlay && closeBtn) {
    cartBtn.addEventListener('click', (e) => { e.preventDefault(); openCartDrawer(); });
    closeBtn.addEventListener('click', () => { closeCartDrawer(); });
    overlay.addEventListener('click', (e) => { if (e.target === overlay) { closeCartDrawer(); } });
  }
  document.body.addEventListener('click', (e) => {
    if (e.target.classList.contains('add-to-cart-trigger')) {
      e.preventDefault();
      const variantId = e.target.getAttribute('data-id');
      if (!variantId || isNaN(parseInt(variantId, 10))) {
        console.error('add-to-cart-trigger is missing a valid Shopify variant id:', variantId);
        return;
      }
      addToCart(variantId, e.target);
    }
  });
  refreshCartFromShopify();
}

function openCartDrawer() {
  const overlay = document.querySelector('.cart-drawer-overlay');
  if (overlay) { overlay.classList.add('active'); document.body.style.overflow = 'hidden'; }
}

function closeCartDrawer() {
  const overlay = document.querySelector('.cart-drawer-overlay');
  if (overlay) { overlay.classList.remove('active'); document.body.style.overflow = ''; }
}

function addToCart(variantId, triggerEl) {
  if (triggerEl) triggerEl.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
  })
    .then(res => { if (!res.ok) return res.json().then(err => Promise.reject(err)); return res.json(); })
    .then(() => refreshCartFromShopify())
    .then(() => { openCartDrawer(); triggerCartNotification(); })
    .catch(err => {
      console.error('Error adding to cart:', err);
      alert((document.documentElement.lang || 'es').startsWith('en')
        ? 'Sorry, we could not add that item to your cart. Please try again.'
        : 'No pudimos agregar ese producto al carrito. Por favor intenta de nuevo.');
    })
    .finally(() => { if (triggerEl) triggerEl.disabled = false; });
}

function refreshCartFromShopify() {
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(res => res.json())
    .then(shopifyCart => {
      cart.items = shopifyCart.items;
      cart.subtotal = shopifyCart.total_price / 100;
      updateCartUI();
      return shopifyCart;
    })
    .catch(err => console.error('Error fetching cart:', err));
}

function updateCartUI() {
  const trackList = document.querySelector('.cart-drawer-body');
  const countBadge = document.querySelector('.cart-count');
  const subtotalEl = document.getElementById('cart-subtotal-val');
  if (!trackList || !countBadge || !subtotalEl) return;
  const itemsContainer = document.querySelector('.cart-items-list') || document.createElement('div');
  itemsContainer.className = 'cart-items-list';
  itemsContainer.innerHTML = '';
  let totalQty = 0;
  let totalSub = 0;
  cart.items.forEach((item) => {
    const lineKey = item.key;
    const linePrice = item.final_line_price / 100;
    totalQty += item.quantity;
    totalSub += linePrice;
    const itemEl = document.createElement('div');
    itemEl.className = 'cart-item';
    itemEl.innerHTML = `
      <div class="cart-item-img">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : '🛍️'}</div>
      <div class="cart-item-details">
        <h4 class="cart-item-title">${item.product_title}</h4>
        <span class="cart-item-meta">${item.variant_title || ''}</span>
        <div class="cart-item-qty">
          <button class="qty-btn dec-qty" data-key="${lineKey}" data-qty="${item.quantity - 1}">-</button>
          <span class="qty-num">${item.quantity}</span>
          <button class="qty-btn inc-qty" data-key="${lineKey}" data-qty="${item.quantity + 1}">+</button>
        </div>
      </div>
      <span class="cart-item-price">$${linePrice.toFixed(2)}</span>
    `;
    itemsContainer.appendChild(itemEl);
  });
  const existingList = document.querySelector('.cart-items-list');
  if (existingList) { existingList.replaceWith(itemsContainer); } else {
    const progressBar = document.querySelector('.cart-progress-bar');
    if (progressBar) { progressBar.after(itemsContainer); } else { trackList.prepend(itemsContainer); }
  }
  cart.subtotal = totalSub;
  countBadge.textContent = totalQty;
  subtotalEl.textContent = `$${totalSub.toFixed(2)}`;
  updateShippingProgress(totalSub);
  document.querySelectorAll('.dec-qty').forEach(btn => { btn.onclick = () => modifyQuantity(btn.dataset.key, parseInt(btn.dataset.qty, 10)); });
  document.querySelectorAll('.inc-qty').forEach(btn => { btn.onclick = () => modifyQuantity(btn.dataset.key, parseInt(btn.dataset.qty, 10)); });
}

function modifyQuantity(lineKey, newQuantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: Math.max(0, newQuantity) })
  })
    .then(res => res.json())
    .then(() => refreshCartFromShopify())
    .catch(err => console.error('Error updating cart quantity:', err));
}

function updateShippingProgress(subtotal) {
  const progressFill = document.querySelector('.progress-fill');
  const progressText = document.querySelector('.cart-progress-text');
  if (!progressFill || !progressText) return;
  const pct = Math.min((subtotal / cart.freeShippingThreshold) * 100, 100);
  progressFill.style.width = `${pct}%`;
  const currentLang = (document.documentElement.lang || 'es').substring(0, 2).toLowerCase();
  if (subtotal >= cart.freeShippingThreshold) {
    progressText.innerHTML = currentLang === 'es' ? '¡Felicidades! Tienes <span>Envío Gratis</span>' : 'Congratulations! You have <span>Free Shipping</span>';
  } else {
    const diff = (cart.freeShippingThreshold - subtotal).toFixed(2);
    progressText.innerHTML = currentLang === 'es' ? `Agrega <span>$${diff}</span> más para <span>Envío Gratis</span>` : `Add <span>$${diff}</span> more for <span>Free Shipping</span>`;
  }
}

function triggerCartNotification() {
  const cartIcon = document.querySelector('.cart-icon-btn');
  if (!cartIcon) return;
  cartIcon.classList.add('pulse');
  setTimeout(() => cartIcon.classList.remove('pulse'), 400);
}

const translations = {
  es: {
    "nav_home": "Inicio", "nav_shop": "Tienda", "nav_history": "Nuestra Historia", "product_tagline": "COLÁGENO MARINO",
    "select_flavor_label": "SELECCIONA TU SABOR:", "buy_flavor_cta": "Comprar 12-Pack", "nav_contact": "Contacto",
    "hero_headline": "Nacida para brillar", "hero_sub": "Belleza caribeña que se bebe y se siente", "hero_cta_primary": "Comprar ahora",
    "hero_cta_secondary": "Descubre la historia", "scroll_down": "Haz Scroll", "benefits_1": "1,000mg Colágeno", "benefits_2": "Sin Azúcar Añadida",
    "benefits_3": "20 Calorías", "benefits_4": "Sabores del Caribe", "benefits_5": "Sin Gluten", "feature_title_1": "Piel Radiante",
    "feature_desc_1": "Contiene 1,000mg de colágeno marino hidrolizado por lata.", "feature_title_2": "Frescura Caribeña",
    "feature_desc_2": "Sabores naturales inspirados en las frutas de nuestra tierra: fresa, piña y lima.", "feature_title_3": "Ritual Saludable",
    "feature_desc_3": "Con solo 20 calorías y sin azúcar añadida, perfecta para disfrutar a diario.", "feature_title_4": "Poder Antioxidante",
    "feature_desc_4": "Contiene Vitamina C.", "duo_tag": "EDICIÓN LIMITADA", "duo_title": "El Dúo de la Reina",
    "duo_desc": "La experiencia completa de belleza de Dayanara Torres. Combina los beneficios hidratantes del colágeno bebible con el poder regenerador de nuestra mascarilla de biocelulosa. El ritual caribeño definitivo para nutrir tu piel por dentro y por fuera.",
    "duo_cta": "Agotado", "dayanara_quote": "El cuerpo necesita que lo cuides por dentro. Mi camino de sanación y autocuidado inspiró Aquanara: belleza consciente nacida de nuestra esencia caribeña.",
    "dayanara_p1": "Fundada por la ex Miss Universo 1993, actriz y filántropa Dayanara Torres, Aquanara Glow nace como un símbolo de belleza, bienestar y empoderamiento latino.",
    "dayanara_p2": "Tras superar con inmensa valentía un diagnóstico de melanoma en etapa 3 en 2019, Dayanara se convirtió en portavoz de la prevención del cáncer de piel e inspiró el célebre 'Efecto Dayanara', concientizando a miles sobre el autocuidado.",
    "dayanara_p3": "Hoy, mientras brilla en grandes producciones (Padres 2024, Premios Juventud), comparte su corona de luz a través de Aquanara: nutrición celular caribeña de alta eficacia.",
    "mask_tag": "CUIDADO INTENSIVO", "mask_title": "Golden Glow Sheet Mask",
    "mask_desc": "Tres mascarillas ultra-hidratantes enriquecidas con Colágeno Marino, Ácido Hialurónico y extracto de Piña. Ideal para refrescar y calmar la piel, aportando un aspecto radiante instantáneo.",
    "ing_1": "Colágeno Marino", "ing_desc_1": "Ayuda a suavizar el aspecto de la piel y aporta firmeza.", "ing_2": "Ácido Hialurónico",
    "ing_desc_2": "Aporta una hidratación intensa y refrescante.", "ing_3": "Extracto de Piña", "ing_desc_3": "Enzimas naturales que exfolian suavemente e iluminan el tono opaco.",
    "mask_cta": "Agregar Mascarilla — $13.23", "reviews_title": "Lo que dicen nuestras Reinas",
    "rev_1": "«El cambio en mi piel a las 3 semanas fue impresionante. La hidratación y el sabor a piña son adictivos.»",
    "rev_2": "«Como sobreviviente de cáncer, cuido mucho lo que pongo en mi cuerpo. Aquanara es mi ritual diario de luz.»",
    "rev_3": "«Uso la mascarilla el domingo y bebo mi agua de colágeno fría todas las mañanas.»",
    "press_title": "Destacado en", "news_tag": "ÚNETE A LA COMUNIDAD", "news_title": "Reinas Aquanara",
    "news_desc": "Suscríbete para recibir tips de belleza de Dayanara, promociones exclusivas y un 15% de descuento en tu primer pedido.",
    "news_placeholder": "Tu correo electrónico...", "news_submit": "Unirme", "footer_tagline": "Belleza caribeña que se bebe y se siente. Nacida en Puerto Rico para el mundo.",
    "footer_col1": "Productos", "footer_col2": "Comunidad", "footer_col3": "Soporte", "footer_col4": "Alianzas", "cart_title": "Tu Carrito",
    "checkout_btn": "Proceder al Checkout", "upsell_title": "¡Completa tu ritual!", "upsell_desc": "Descubre el resto del ritual Aquanara", "upsell_btn": "Agregar",
    "bf_tag": "NUESTRA CO-CREACIÓN", "bf_title": "A Brand Factoria Venture",
    "bf_desc": "Aquanara es co-creada junto a Brand Factoria, el estudio de marcas dedicado a impulsar la cultura latina y el talento hispano en el sector de la belleza y el bienestar premium. Juntos unimos la ciencia del cuidado personal con la autenticidad de nuestras raíces.",
    "bf_btn": "Conoce Brand Factoria", "footer_privacy_choices": "Tus Opciones de Privacidad", "privacy_title": "Tus Opciones de Privacidad",
    "privacy_tag": "PRIVACIDAD Y CONTROL",
    "privacy_intro_1": "Tal como se describe en nuestra Política de Privacidad, recopilamos información personal a partir de tus interacciones con nosotros y nuestro sitio web, incluso a través de cookies y tecnologías similares. También podemos compartir esta información con terceros, incluidos socios publicitarios, para mostrarte anuncios más relevantes en otros sitios web.",
    "privacy_intro_2": "El uso compartido de información personal para publicidad dirigida basada en tu interacción en diferentes sitios web puede considerarse una 'venta', 'intercambio' o 'publicidad dirigida' según ciertas leyes de privacidad estatales de EE. UU. Según tu lugar de residencia, tienes derecho a excluirte (opt out) de estas actividades. Si deseas ejercer este derecho, sigue las instrucciones a continuación.",
    "privacy_intro_3": "Si visitas nuestro sitio web con la señal de preferencia de exclusión voluntaria del Control de Privacidad Global (GPC) habilitada, según el lugar donde te encuentres, trataremos esto como una solicitud para excluirte de las actividades que puedan considerarse una 'venta' o 'intercambio' de información personal para el dispositivo y el navegador que utilizaste para visitar nuestro sitio web.",
    "privacy_toggle_title": "Excluir el uso de cookies en este dispositivo", "privacy_toggle_desc": "Al activar esta opción, indicaremos a este navegador que no rastree tus datos personales con fines publicitarios en este dispositivo. (Se utiliza una cookie local para recordar tu preferencia).",
    "privacy_email_label": "Dirección de Correo Electrónico", "privacy_email_placeholder": "ejemplo@correo.com",
    "privacy_checkbox_account": "No compartir ni vender la información de mi cuenta de cliente (opcional)", "privacy_btn": "Confirmar Preferencias (Opt Out)",
    "privacy_success": "¡Tus preferencias de privacidad han sido actualizadas con éxito!"
  },
  en: {
    "nav_home": "Home", "nav_shop": "Shop", "nav_history": "Our Story", "product_tagline": "MARINE COLLAGEN", "select_flavor_label": "SELECT YOUR FLAVOR:",
    "buy_flavor_cta": "Buy 12-Pack", "nav_contact": "Contact", "hero_headline": "Born to glow", "hero_sub": "Caribbean beauty to drink and feel",
    "hero_cta_primary": "Shop Now", "hero_cta_secondary": "Discover the story", "scroll_down": "Scroll Down", "benefits_1": "1,000mg Collagen",
    "benefits_2": "No Sugar Added", "benefits_3": "20 Calories", "benefits_4": "Caribbean Flavors", "benefits_5": "Gluten Free", "feature_title_1": "Radiant Skin",
    "feature_desc_1": "Contains 1,000mg of hydrolyzed marine collagen per can.", "feature_title_2": "Caribbean Freshness",
    "feature_desc_2": "Natural flavors inspired by fruits of our land: strawberry, juicy pineapple, and lime.", "feature_title_3": "Healthy Ritual",
    "feature_desc_3": "With only 20 calories and no added sugar, perfect for daily enjoyment.", "feature_title_4": "Antioxidant Power", "feature_desc_4": "Contains Vitamin C.",
    "duo_tag": "LIMITED EDITION", "duo_title": "The Queen's Duo",
    "duo_desc": "The complete beauty experience by Dayanara Torres. Combines the hydrating benefits of drinkable collagen with the restoring power of our bio-cellulose sheet mask. The ultimate Caribbean ritual to nourish your skin inside and out.",
    "duo_cta": "Sold Out",
    "dayanara_quote": "Your body needs you to care for it from within. My healing and self-care journey inspired Aquanara: conscious beauty born from our Caribbean essence.",
    "dayanara_p1": "Founded by former Miss Universe 1993, actress, and philanthropist Dayanara Torres, Aquanara Glow is a symbol of beauty, wellness, and Latina empowerment.",
    "dayanara_p2": "After bravely facing a stage 3 melanoma diagnosis in 2019, Dayanara became a skin cancer awareness spokesperson, inspiring the renowned 'Dayanara Effect' for preventative care.",
    "dayanara_p3": "Today, while starring in major productions (Padres 2024, Premios Juventud), she shares her crown of light through Aquanara: high-efficacy Caribbean cellular nutrition.",
    "mask_tag": "INTENSE TREATMENT", "mask_title": "Golden Glow Sheet Mask",
    "mask_desc": "Three ultra-hydrating sheet masks enriched with Marine Collagen, Hyaluronic Acid, and Pineapple extract. Perfect to refresh and soothe the skin, delivering an instant radiant glow.",
    "ing_1": "Marine Collagen", "ing_desc_1": "Helps soften the appearance of the skin and provides firmness.", "ing_2": "Hyaluronic Acid",
    "ing_desc_2": "Holds up to 1,000 times its weight in water for deep skin hydration.", "ing_3": "Pineapple Extract",
    "ing_desc_3": "Natural enzymes that gently exfoliate and brighten dull complexions.", "mask_cta": "Add Mask — $13.23", "reviews_title": "What our Queens say",
    "rev_1": "«The change in my skin after 3 weeks was impressive. The hydration and pineapple flavor are addictive.»",
    "rev_2": "«As a cancer survivor, I care deeply about what I put in my body. Aquanara is my daily ritual of light.»",
    "rev_3": "«I use the mask on Sundays and drink my cold collagen water every morning.»",
    "press_title": "Featured in", "news_tag": "JOIN THE COMMUNITY", "news_title": "Aquanara Queens",
    "news_desc": "Subscribe to receive beauty tips from Dayanara, exclusive promotions, and 15% off your first order.", "news_placeholder": "Your email address...", "news_submit": "Join Us",
    "footer_tagline": "Caribbean beauty to drink and feel. Born in Puerto Rico for the world.", "footer_col1": "Products", "footer_col2": "Community",
    "footer_col3": "Support", "footer_col4": "Partners", "cart_title": "Your Cart", "checkout_btn": "Proceed to Checkout", "upsell_title": "Complete your ritual!",
    "upsell_desc": "Discover the rest of the Aquanara ritual", "upsell_btn": "Add", "bf_tag": "OUR CO-CREATION", "bf_title": "A Brand Factoria Venture",
    "bf_desc": "Aquanara is co-created with Brand Factoria, a consumer brand studio dedicated to empowering Hispanic talent in the premium beauty and wellness category. Together, we merge the science of personal care with the authenticity of our roots.",
    "bf_btn": "Explore Brand Factoria", "footer_privacy_choices": "Your Privacy Choices", "privacy_title": "Your Privacy Choices", "privacy_tag": "PRIVACY & CONTROL",
    "privacy_intro_1": "As described in our Privacy Policy, we collect personal information from your interactions with us and our website, including through cookies and similar technologies. We may also share this personal information with third parties, including advertising partners. We do this in order to show you ads on other websites that are more relevant to your interests and for other reasons outlined in our privacy policy.",
    "privacy_intro_2": "Sharing of personal information for targeted advertising based on your interaction on different websites may be considered 'sales', 'sharing', or 'targeted advertising' under certain U.S. state privacy laws. Depending on where you live, you may have the right to opt out of these activities. If you would like to exercise this opt-out right, please follow the instructions below.",
    "privacy_intro_3": "If you visit our website with the Global Privacy Control opt-out preference signal enabled, depending on where you are, we will treat this as a request to opt-out of activity that may be considered a 'sale' or 'sharing' of personal information or other uses that may be considered targeted advertising for the device and browser you used to visit our website.",
    "privacy_toggle_title": "Opt out of cookie sharing on this device",
    "privacy_toggle_desc": "By toggling this option, the browser on this device will be opted out of sharing personal data via cookies. (A local cookie is used to remember your preference).",
    "privacy_email_label": "Email Address", "privacy_email_placeholder": "example@email.com", "privacy_checkbox_account": "Don't share or sell data from my customer account (optional)",
    "privacy_btn": "Confirm Choices (Opt Out)", "privacy_success": "Your privacy choices have been successfully updated!"
  }
};

function initLanguageSwitcher() {
  const selectEls = document.querySelectorAll('.lang-select-btn, .footer-select[name="lang"]');
  selectEls.forEach(el => {
    el.addEventListener('change', (e) => {
      const selectedLang = e.target.value;
      switchLanguage(selectedLang);
      selectEls.forEach(sync => { if(sync !== el) sync.value = selectedLang; });
    });
    el.addEventListener('click', (e) => {
      if(e.target.tagName === 'BUTTON') {
        const selectedLang = e.target.getAttribute('data-lang');
        if(selectedLang) switchLanguage(selectedLang);
      }
    });
  });
}

function switchLanguage(rawLang) {
  const lang = rawLang.substring(0, 2).toLowerCase();
  if (!translations[lang]) return;
  document.documentElement.lang = lang;
  const translatableElements = document.querySelectorAll('[data-t]');
  translatableElements.forEach(el => {
    const key = el.getAttribute('data-t');
    if (translations[lang][key]) {
      if (el.tagName === 'INPUT' && el.type === 'email') { el.placeholder = translations[lang][key]; } else { el.innerHTML = translations[lang][key]; }
    }
  });
  updateShippingProgress(cart.subtotal);
}

function initFaqAccordion() {
  const triggers = document.querySelectorAll('.faq-trigger');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const parent = trigger.parentElement;
      const content = trigger.nextElementSibling;
      const isActive = parent.classList.contains('active');
      document.querySelectorAll('.faq-item').forEach(item => { item.classList.remove('active'); item.querySelector('.faq-content').style.maxHeight = null; });
      if (!isActive) { parent.classList.add('active'); content.style.maxHeight = content.scrollHeight + 'px'; }
    });
  });
}

function initPdpGallery() {
  const thumbs = document.querySelectorAll('.pdp-thumb');
  const mainImg = document.querySelector('.pdp-main-img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const newSrc = thumb.getAttribute('data-large');
        if (newSrc) { mainImg.setAttribute('src', newSrc); mainImg.classList.add('fade-in'); setTimeout(() => mainImg.classList.remove('fade-in'), 500); }
      });
    });
  }
}

function initQuantityPickers() {
  const decBtn = document.querySelector('.pdp-qty-dec');
  const incBtn = document.querySelector('.pdp-qty-inc');
  const valEl = document.querySelector('.pdp-qty-val');
  if (decBtn && incBtn && valEl) {
    decBtn.addEventListener('click', () => { let val = parseInt(valEl.textContent); if (val > 1) { valEl.textContent = val - 1; } });
    incBtn.addEventListener('click', () => { let val = parseInt(valEl.textContent); valEl.textContent = val + 1; });
  }
}

function initMobileNav() {
  const headerActions = document.querySelector('.header-actions');
  if (headerActions && !document.querySelector('.mobile-nav-trigger')) {
    const trigger = document.createElement('button');
    trigger.className = 'mobile-nav-trigger';
    trigger.setAttribute('aria-label', 'Abrir Menú');
    trigger.innerHTML = `
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
    `;
    const cartBtn = headerActions.querySelector('.cart-icon-btn');
    if (cartBtn) { headerActions.insertBefore(trigger, cartBtn.nextSibling); } else { headerActions.appendChild(trigger); }
  }

  if (!document.querySelector('.mobile-drawer-overlay')) {
    const drawerHTML = `
      <div class="mobile-drawer-overlay">
        <div class="mobile-drawer">
          <div class="mobile-drawer-header">
            <div class="logo-wrap">
              <a href="index.html">
                <img src="${window.ShopifyThemeAssets?.logo || 'shopify-theme/assets/LOGO_AQUANARA_TRANSPARENT.png'}" alt="AQUANARA GLOW" style="height: 42px;">
              </a>
            </div>
            <button class="mobile-drawer-close" aria-label="Cerrar Menú">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="mobile-drawer-body">
            <ul class="mobile-nav-menu">
              <li><a href="${window.ShopifyThemeAssets ? '/' : 'index.html'}" class="mobile-nav-link" data-t="nav_home">Inicio</a></li>
              <li><a href="${window.ShopifyThemeAssets ? '/collections/all' : 'collection.html'}" class="mobile-nav-link" data-t="nav_shop">Tienda</a></li>
              <li><a href="${window.ShopifyThemeAssets ? '/pages/nuestra-historia' : 'story.html'}" class="mobile-nav-link" data-t="nav_history">Nuestra Historia</a></li>
              <li><a href="https://brandfactoria.com/" target="_blank" rel="noopener" class="mobile-nav-link">Brand Factoria</a></li>
            </ul>
            <div class="mobile-drawer-footer">
              <div class="mobile-lang-wrap">
                <span style="font-size: 0.85rem; color: var(--color-text-light); text-transform: uppercase; letter-spacing: 0.1em; display: block; margin-bottom: 8px;">Idioma / Language</span>
                <select class="lang-select-btn mobile-lang-select" name="lang" aria-label="Idioma">
                  <option value="es">Español (ES)</option>
                  <option value="en">English (EN)</option>
                </select>
              </div>
              <div class="mobile-social-wrap">
                <a href="https://www.instagram.com/aquanara_beauty/" target="_blank" rel="noopener" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                </a>
                <a href="https://www.facebook.com/profile.php?id=61591052309524" target="_blank" rel="noopener" aria-label="Facebook">
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', drawerHTML);
  }

  const mobileTrigger = document.querySelector('.mobile-nav-trigger');
  const mobileOverlay = document.querySelector('.mobile-drawer-overlay');
  const mobileCloseBtn = document.querySelector('.mobile-drawer-close');
  if (mobileTrigger && mobileOverlay && mobileCloseBtn) {
    mobileTrigger.addEventListener('click', (e) => { e.preventDefault(); mobileOverlay.classList.add('active'); document.body.style.overflow = 'hidden'; });
    mobileCloseBtn.addEventListener('click', (e) => { e.preventDefault(); mobileOverlay.classList.remove('active'); document.body.style.overflow = ''; });
    mobileOverlay.addEventListener('click', (e) => { if (e.target === mobileOverlay) { mobileOverlay.classList.remove('active'); document.body.style.overflow = ''; } });
    const mobileLinks = mobileOverlay.querySelectorAll('.mobile-nav-link');
    mobileLinks.forEach(link => { link.addEventListener('click', () => { mobileOverlay.classList.remove('active'); document.body.style.overflow = ''; }); });
  }

  const desktopSelect = document.querySelector('.lang-select-btn:not(.mobile-lang-select)');
  const mobileSelect = document.querySelector('.mobile-lang-select');
  if (desktopSelect && mobileSelect) { mobileSelect.value = desktopSelect.value; }
}
